export const MIN_INPUT_LENGTH = 3
export const DEFAULT_START_PAGE = 1
export const DEFAULT_PAGE_SIZE = 10
